import React, { forwardRef, useEffect, useState } from 'react';
import axios from 'axios';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import ru from 'date-fns/locale/ru';

import './BookingPage.css';

import bookingImage from './../../image/image-5.jpg';
import bookingMinus from './../../image/minus-btn.svg';
import bookingPlus from './../../image/plus-btn.svg';
import bookingClose from './../../image/close.svg';

const BookingPage = ({
    setCurrentPage,
    setSuccessStatus,
    setIsShowSuccess,
    setErrorStatus,
    setIsShowError,
    telephoneUser,
    setTelephoneUser,
}) => {
    const [countValue, setCountValue] = useState(1);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(new Date());

    const BookingInputDate = forwardRef(
        ({ value, onClick, className }, ref) => (
            <button className={className} onClick={onClick} ref={ref}>
                {value ? value : 'Дата'}
            </button>
        )
    );

    const BookingInputTime = forwardRef(
        ({ value, onClick, className }, ref) => (
            <button className={className} onClick={onClick} ref={ref}>
                {value ? value : 'Время'}
            </button>
        )
    );

    // фильтрация времени
    const filterTime = (time) => {
        const selected = new Date(time);
        const hours = selected.getHours();
        const minutes = selected.getMinutes();

        // 12:00 до 02:00
        if (hours >= 12 || hours < 1) {
            return true;
        }

        if (hours === 1 && minutes === 0) {
            return true;
        }

        return false;
    };

    const handleMinusClick = () => {
        if (countValue > 1) {
            setCountValue(countValue - 1);
        }
    };

    const handlePlusClick = () => {
        if (countValue < 20) {
            setCountValue(countValue + 1);
        }
    };

    const handleCloseClick = () => {
        setCurrentPage('MainPage');
    };

    const handleTelClick = (e) => {
        setTelephoneUser(e.target.value);
    };

    const handlePhoneChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');
        let formattedInput = '';

        if (input.length > 0) {
            formattedInput += '+7 ';
            if (input.length > 1) {
                formattedInput += `(${input.substring(1, 4)}`;
            }
            if (input.length > 4) {
                formattedInput += `) ${input.substring(4, 7)}`;
            }
            if (input.length > 7) {
                formattedInput += `-${input.substring(7, 9)}`;
            }
            if (input.length > 9) {
                formattedInput += `-${input.substring(9, 11)}`;
            }
        }

        setTelephoneUser(formattedInput);
    };

    const handleSaveClick = async () => {
        if (!selectedDate || !selectedTime) {
            alert('Выберите дату и время');
            return;
        }

        if (!telephoneUser) {
            alert('Введите номер телефона');
            return;
        }

        const valueDateTime = new Date(selectedDate);
        valueDateTime.setHours(selectedTime.getHours());
        valueDateTime.setMinutes(selectedTime.getMinutes());

        const valueDateTimeUTC = valueDateTime.toISOString();

        const bookingData = {
            date: valueDateTimeUTC,
            count: countValue,
            telephone: telephoneUser,
        };

        console.log('bookingData:', bookingData);

        try {
            const response = await axios.post(
                'https://apihpwild.ru/user/reserve/create',
                bookingData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                setSuccessStatus(1);
                setIsShowSuccess(true);
            }
        } catch (error) {
            console.error('Ошибка при бронировании ', error);
            console.error(
                'error.response.data: ',
                error.response.data.error.message
            );
            if (error.response.data.error.message === 'DATE LESS NOW') {
                setErrorStatus(1);
                setIsShowError(true);
            }
            if (error.response.data.error.message === 'LIMIT COUNT RESERVE') {
                setErrorStatus(2);
                setIsShowError(true);
            }
        }
    };

    return (
        <div className='booking__wrapper'>
            <h1 className='booking__title'>Бронирование</h1>
            <div className='booking__close' onClick={handleCloseClick}>
                <img src={bookingClose} alt='Close' />
            </div>
            <div className='booking__image'>
                <img src={bookingImage} />
            </div>
            <div className='booking__form'>
                <div className='booking__input_date'>
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat='dd.MM.yyyy'
                        disabledKeyboardNavigation
                        locale={ru}
                        customInput={
                            <BookingInputDate className='booking__input' />
                        }
                        minDate={new Date()}
                        maxDate={
                            new Date(
                                new Date().setMonth(new Date().getMonth() + 3)
                            )
                        }
                    />
                </div>

                <div>
                    <DatePicker
                        selected={selectedTime}
                        onChange={(time) => setSelectedTime(time)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat='HH:mm'
                        locale={ru}
                        customInput={
                            <BookingInputTime className='booking__input' />
                        }
                        filterTime={filterTime}
                    />
                </div>
                <input
                    type='tel'
                    value={telephoneUser}
                    placeholder={!telephoneUser && 'Номер телефона'}
                    className='booking__input'
                    onChange={handlePhoneChange}
                    maxLength={18}
                />
                <div className='booking__form_items'>
                    <h3>Количество гостей</h3>
                    <div className='booking__add_input'>
                        <div
                            className='booking__minus_btn'
                            onClick={handleMinusClick}
                        >
                            <img src={bookingMinus} />
                        </div>
                        <p>{countValue}</p>
                        <div
                            className='booking__plus_btn'
                            onClick={handlePlusClick}
                        >
                            <img src={bookingPlus} />
                        </div>
                    </div>
                </div>
                <div className='booking__form_btn' onClick={handleSaveClick}>
                    Забронировать
                </div>
            </div>
            <div className='booking__text'>
                Нажимая кнопку «Забронировать»,Вы соглашаетесь на обработку
                персональных данных, согласно{' '}
                <a
                    href='https://hp-wild.ru/about'
                    target='_blank'
                    rel='noopener'
                >
                    политике конфиденциальности
                </a>
                .
            </div>
        </div>
    );
};

export default BookingPage;
